import React, { useRef, useEffect } from 'react';
import { InputNumber } from 'antd';
import classNames from 'classnames';

function EnhancedInputNumber(props) {
  const ref = useRef(null);

  useEffect(() => {
    // if you set attribute for InputNumber component, it will not set for container.
    ref.current?.children[0]?.setAttribute('data-addonAfter', props.addonAfter);
  }, [props.addonAfter]);

  return (
    <div ref={ref} className="enhanced-input-number" data-addonAfter={props.addonAfter}>
      <InputNumber
        data-addonAfter={props.addonAfter}
        className={classNames('enhanced-input-number__input', {
          'enhanced-input-number__input--have-addonAfter': props.addonAfter,
        })}
        {...props}
      />
    </div>
  );
}

export default EnhancedInputNumber;
